import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { MealHelper } from 'src/app/helpers';
import { MealTime } from 'src/app/models';
import { APP_STATE_TOKEN } from 'src/app/store/app/app.state.model';
import { LOCATION_STATE_TOKEN } from 'src/app/store/location/location.state';

@Injectable({
  providedIn: 'root'
})
export class MealProvider {
  constructor(private readonly _store: Store) {}

  getCurrentMealId(): MealTime {
    const facilityTimeZone =
      this._store.selectSnapshot(APP_STATE_TOKEN)?.facility_details?.time_zone;
    return MealHelper.getMealIdByTime(
      this._store.selectSnapshot(LOCATION_STATE_TOKEN).location.meal_end_times,
      facilityTimeZone
    );
  }
}
